var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaginationLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.28 19c.442 0 .886.17 1.224.515.303.309.468.705.493 1.108.02.329-.053.661-.216.955l-.076.123-6.613 6.787c-.29.295-.657.463-1.035.505-.01.005-.022.008-.034.007l-.022-.002-.024.002c-.012 0-.024-.002-.035-.007-.33-.037-.652-.17-.922-.4l-.112-.105-6.613-6.787-.076-.123c-.163-.294-.236-.626-.216-.955.025-.403.19-.8.493-1.108.304-.31.694-.48 1.092-.51L17.72 19l.132.005c.354.027.701.164.988.412l.104.098L24 24.67l5.055-5.154c.338-.345.782-.515 1.224-.515z",
    transform: "matrix(0 -1 -1 0 48 48)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeft);
export default __webpack_public_path__ + "static/media/pagination-left.658a9fd3cbaae25f9a467bcfdbc4bbfb.svg";
export { ForwardRef as ReactComponent };